<template>
	<div>
		<v-card :flat="flat" class="mb-4">
			<div v-if="showHeader">
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">
						<v-icon>mdi-bullseye-arrow</v-icon>
						{{ headerTitle }}
					</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
				</v-toolbar>
				<v-divider></v-divider>
			</div>
			<!-- <div v-else class="pt-2"></div> -->

			<v-card-text>
				<div v-if="showAddButtonAboveContent" class="text-xs-right mb-3">
					<v-btn @click="onAddGoal" :color="goals.filter(x => !x.complete).length === 0 ? 'primary' : ''">Add Goal</v-btn>
				</div>
				<v-layout row wrap>
					<v-flex sm6>
						<v-switch v-model="showCompleteGoals">
							<template v-slot:label>
								<span>Show Completed Goals</span>
							</template>
						</v-switch>
					</v-flex>
					<v-flex sm6>
						<v-select v-model="filterCategory" :items="filterCategories" label="Goal Type" item-text="text" item-value="value" required></v-select>
					</v-flex>
				</v-layout>

				<v-subheader v-show="filteredGoals !== null && filteredGoals.length == 0" class="no-goals-text">
					{{ noGoalsText }}
				</v-subheader>

				<v-list two-line dense>
					<template v-for="(item, index) in filteredGoals">
						<v-list-tile :key="index" :class="{ 'goal-complete': item.complete }" @click="onViewGoal(item)">
							<v-list-tile-content>
								<v-list-tile-title v-html="item.goal"></v-list-tile-title>
								<v-list-tile-sub-title v-if="!item.complete">
									<v-chip :color="getCategoryChipColor(item.category)" class="v-chip--x-small white--text mr-3">{{ getCategoryChipText(item.category, true) }}</v-chip
									>Due:
									<AppDate :date="item.dueDateUTC" null-date="N/A" show-date />
								</v-list-tile-sub-title>

								<div v-if="item.complete">
									<v-chip :color="getCategoryChipColor(item.category)" class="v-chip--x-small white--text">{{ getCategoryChipText(item.category, true) }}</v-chip>								
								</div>
							</v-list-tile-content>

							<v-list-tile-action>
								<goal-progress v-if="!item.complete" :goal="item" />
								<v-chip v-else color="green" class="v-chip--x-small" text-color="white">
										Complete
									</v-chip>
							</v-list-tile-action>
						</v-list-tile>
					</template>
				</v-list>
			</v-card-text>
			<v-card-actions v-if="!hideFooter">
				<v-spacer></v-spacer>
				<v-btn flat @click="onAddGoal"> <v-icon left>add</v-icon>Add Goal </v-btn>
			</v-card-actions>
		</v-card>

		<employee-goal-editor
			v-if="goalEditorDialog"
			:title="goalEditorTitle"
			:dialog="goalEditorDialog"
			:goal="editedGoal"
			:category="filterCategory !== -1 ? filterCategory : 2"
			:employeeId="employeeId"
			@onSaved="onGoalSaved"
			@onDeleted="onGoalDeleted"
			@closeEditor="goalEditorDialog = false"
		></employee-goal-editor>
	</div>
</template>

<script>
	import EmployeeGoalEditor from '@/components/employee/EmployeeGoalEditor';
	import goalsMixin from '@/mixins/goalsMixin';
	import GoalProgress from '@/components/goals/GoalProgress';

	export default {
		props: {
			employeeId: {
				type: String,
				required: true
			},
			goals: {
				type: Array,
				required: true
			},
			showHeader: {
				type: Boolean,
				required: false,
				default: true
			},
			flat: {
				type: Boolean,
				required: false,
				default: false
			},
			headerTitle: {
				type: String,
				required: false,
				default: 'Goals'
			},
			hideFooter: {
				type: Boolean,
				required: false
			},
			showAddButtonAboveContent: {
				type: Boolean,
				required: false
			}
		},
		components: {
			EmployeeGoalEditor,
			GoalProgress
		},
		mixins: [goalsMixin],
		data() {
			return {
				showCompleteGoals: false,
				goalEditorDialog: false,
				editedGoalIndex: -1,
				editedGoal: undefined,
				filterCategory: -1
			};
		},
		computed: {
			filteredGoals() {
				if (this.showCompleteGoals) {
					return this.goals.filter(x => (this.filterCategory > -1 ? x.category === this.filterCategory : 1 === 1));
				} else {
					return this.goals.filter(x => x.complete !== true && (this.filterCategory > -1 ? x.category === this.filterCategory : 1 === 1));
				}
			},
			goalEditorTitle() {
				return this.editedGoalIndex === -1 ? 'Create Goal' : 'Edit Goal';
			},
			completedGoalCount() {
				return this.goals.filter(x => x.complete === true).length;
			},
			noGoalsText() {
				if (this.filterCategory > -1) {
					return `No ${this.filterCategories.find(x => x.value === this.filterCategory).text} setup!`;
				} else {
					return 'No goals setup!';
				}
			}
		},
		methods: {
			onViewGoal(goal) {
				this.$router.push({name: "employeeGoal", params: {
					id: goal.id,
					employeeId: this.employeeId,
					goalPreloaded: goal
				}});
			},
			onEditGoal(item) {
				this.editedGoalIndex = this.goals.indexOf(item);
				this.editedGoal = Object.assign({}, item);
				this.goalEditorDialog = true;
			},
			onAddGoal() {
				this.editedGoalIndex = -1;
				this.editedGoal = undefined;
				this.goalEditorDialog = true;
			},
			onGoalSaved(goal) {
				if (this.editedGoalIndex > -1) {
					this.$emit('onGoalEdited', { employeeId: this.employeeId, goal });
				} else {
					this.$emit('onGoalAdded', { employeeId: this.employeeId, goal });
				}
				this.goalEditorDialog = false;
			},
			onGoalDeleted(id) {
				this.$emit('onGoalDeleted', { employeeId: this.employeeId, id });
				this.goalEditorDialog = false;
			}
		}
	};
</script>

<style scoped>
	.goal-complete {
		background-color: rgba(0, 255, 0, 0.1);
	}
	.no-goals-text span {
		margin-right: 5px;
	}
	.v-input--radio-group--row {
		float: right;
	}
	.v-sheet {
		border-radius: 0;
	}
</style>
